<div style="border-radius: 50%;">
<div>
  <p>{{ message }}</p>  
</div>
<div style="text-align: center;">
  <button class="btn btn-primary" (click)="onNoClick()">Ok</button>
</div>
</div>